var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:search",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4983 14.2933L10.7223 10.5173C11.6297 9.42796 12.0822 8.03072 11.9857 6.61625C11.8891 5.20179 11.251 3.879 10.204 2.92306C9.15696 1.96712 7.78172 1.45164 6.36433 1.48384C4.94694 1.51605 3.59653 2.09347 2.59402 3.09597C1.59151 4.09848 1.0141 5.44889 0.981892 6.86628C0.949686 8.28367 1.46517 9.65892 2.42111 10.7059C3.37704 11.7529 4.69983 12.3911 6.1143 12.4876C7.52877 12.5842 8.92601 12.1317 10.0153 11.2243L13.7913 15.0003L14.4983 14.2933ZM1.99835 7.0003C1.99835 6.11029 2.26227 5.24026 2.75674 4.50024C3.2512 3.76021 3.95401 3.18344 4.77627 2.84284C5.59854 2.50225 6.50334 2.41313 7.37626 2.58677C8.24917 2.7604 9.05099 3.18899 9.68033 3.81832C10.3097 4.44766 10.7382 5.24948 10.9119 6.1224C11.0855 6.99531 10.9964 7.90011 10.6558 8.72238C10.3152 9.54464 9.73844 10.2474 8.99841 10.7419C8.25839 11.2364 7.38836 11.5003 6.49835 11.5003C5.30528 11.499 4.16146 11.0244 3.31783 10.1808C2.4742 9.33719 1.99967 8.19337 1.99835 7.0003Z",
    fill: "#464646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.0cf887b0c68069bd676c4fadf4b3bb26.svg";
export { ForwardRef as ReactComponent };